import React, { useState } from "react";
import { InterviewExperienceAPI } from "../../api/InterviewExperienceAPI";
import { InterviewExperienceResponse } from "../../model/InterviewExperience";
import { Api, ApiMethod } from "../common/ApiLinkedButton";
import { ApiLinkedButtonV3 } from "../common/Form/ApiLinked.button.V3";
import { AiConfigSelector, AiProvider } from "./AiConfig.Selector";

export function AdminInterviewExperienceAIPage() {
  const [rawInterviewExperienceContent, setRawInterviewExperienceContent] =
    useState("");
  const [aiProvider, setAiProvider] = useState<AiProvider>("GEMINI_VIA_REST");
  const [modelName, setModelName] = useState("gemini-1.5-flash");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<any | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setResult(null);

    InterviewExperienceAPI.addInterviewExperienceUsingAI(aiProvider, modelName)
      .executeV2({ rawContent: rawInterviewExperienceContent })
      .then((response) => {
        setResult(response);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="main-container">
      <h1>Create Interview Experience using AI</h1>
      <ApiLinkedButtonV3
        buttonProps={{
          content: {
            normal:
              "Create Interview Experience using next raw content availabel in the system",
            submitting: "Creating Interview Experience...",
          },
        }}
        className="mb-3"
        api={
          new Api<InterviewExperienceResponse, void>(
            "/api/raw-content/process-next",
            ApiMethod.POST
          )
        }
        uniqueKey={"admin-raw-content-process-next"}
      />
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="rawContent">Raw Interview Experience Content</label>
          <textarea
            id="rawContent"
            className="form-control"
            rows={15}
            value={rawInterviewExperienceContent}
            onChange={(e) => setRawInterviewExperienceContent(e.target.value)}
            required
          />
        </div>
        <AiConfigSelector
          aiProvider={aiProvider}
          setAiProvider={setAiProvider}
          modelName={modelName}
          setModelName={setModelName}
        />
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Creating..." : "Create"}
        </button>
      </form>
      {error && <div className="alert alert-danger mt-3">{error}</div>}
      {result && (
        <div className="alert alert-success mt-3">
          <p>Successfully created interview experience!</p>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
